const utils = require("frontend-controller/lib/utils");
module.exports = {
    extends: [
        '/',
        'templates',
        'office',
        'projectTerms',
        'table',
    ],

    config: {
        projectsControllerComponentClass: 'templates_office_projects_controller',
        projectTermsControllerComponentClass: 'templates_office_projectTerms_controller',
        problemSummaryComponentClass: 'templates_core_projectTerms_problemSummary',

        buttonContext: 'projectTerms',
        showHead: false,
        // showIDs: true,
        // // showTDVerticalTop: true,
        // isSortable: true,
        // preventSortOfField: {
        //     statusFlagsSummary: true,
        // },
        // rowActionsInline: true,
        // rowActionsProperties: {
        //     colWidth: '105px',
        // },
        // rowActions: {
        //     edit: true,
        //     customs: [
        //         // {
        //         //     buttonType: 'showLocation',
        //         // },
        //         {
        //             buttonType: 'delete',
        //             neutral: true,
        //         }
        //     ]
        // },
        // heartbeatRefreshOn: {
        //     'reconnect': true,
        //     'resourceChanged.bo_status': true,
        //     'resourceChanged.bo_projectTerms': true,
        // },
    },

    // model: {
    //     resourceFilters: {
    //         order: [{
    //             fieldCode: 'timeRange',
    //             direction: 'asc'
    //         },{
    //             fieldCode: 'projectTermID',
    //             direction: 'asc'
    //         }]
    //     }
    // },

    events: {
        showProblemSummary: {
            type: 'mouseenter',
            selector: 'tbody',
            action: function(event){
                const self = event.data.component;
                const $target = $(event.target).closest('tbody')
                if($target.length > 0){
                    const rowID = $target.data('rowId')
                    if(rowID){
                        self.showProblemSummary(rowID)
                    }
                }
            }
        },

        hideProblemSummary: {
            type: 'mouseleave',
            selector: 'tbody',
            action: function(event){
                event.data.component.hideProblemSummary()
            }
        },
    },

    methods: {

        async showEdit(rowID, rowData){
            const { projectID, projectTermID } = (rowData || {}).attributes || {}

            if(!projectID || !projectTermID) return;

            const projectsController = getComponent($(`.${this.config.projectsControllerComponentClass}`))
            if(!projectsController) return;

            const actionContext = await projectsController.showEdit('projects', projectID, {
                attributes: { projectID },
                primaryKey: 'projectID'
            })

            let projectTermsController
            actionContext.component.find(this.config.projectTermsControllerComponentClass, c => {
                const foundProjectID = ((((c.model || {}).parentEntity || {}).entityData || {}).attributes || {}).projectID
                if(projectID == foundProjectID){
                    projectTermsController = c
                    return 'break'
                }
            })

            if(!projectTermsController) return;
            return projectTermsController.showEdit('projectTerms', projectTermID, {
                attributes: { projectTermID },
                primaryKey: 'projectTermID'
            })
        },

        showProblemSummary(rowID){
            if(!rowID) return;

            const rowData = this.getRowData(rowID)
            const {problemSummary} = ((rowData || {}).attributes || {}).statusFlagsSummary || {}
            if(!problemSummary) return;

            if(!this.model.controllerComponent){
                this.locate(`< templates_core_controller_controller`, c => this.model.controllerComponent = c)
            }
            if(!this.model.controllerComponent) return;
            if(!this.model.problemSummaryComponent && this.config.problemSummaryComponentClass){
                this.locate(`< templates_core_controller_controller > ${this.config.problemSummaryComponentClass}`, c => this.model.problemSummaryComponent = c)
            }
            if(!this.model.problemSummaryComponent) return;

            this.model.controllerComponent.showAdditionalContent()

            this.model.problemSummaryComponent.update(problemSummary)
        },

        hideProblemSummary(){
            if(!this.model.controllerComponent) return;
            this.model.controllerComponent.hideAdditionalContent()
        },
    },
}